import { APICallV4Post } from '../APICall';

export class ComplaintDocumentApiCall extends APICallV4Post {
    _method = 'weblinks/email/access/complaint';
}

export const callWeblinksComplaintApiCall = async (data) => new ComplaintDocumentApiCall().makeRequest(data);
